/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgReorderColumns = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M2 2h9v5H9V4H4v16h5v-1h2v3H2zm11 0h9v20h-9v-5h2v3h5V4h-5v1h-2zm1.707 4.293L17.914 9.5l-3.207 3.207-1.414-1.414.793-.793H7v-2h7.086l-.793-.793zM9.914 15.5l.793.793-1.414 1.414L6.086 14.5l3.207-3.207 1.414 1.414-.793.793H17v2z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgReorderColumns as ReorderColumns };
